import styled from 'styled-components';
import { ModalDisableCheckoutStyled } from '../ModalDisableCheckoutStyled';

export const ModalDisableCheckoutStyledAP = styled(ModalDisableCheckoutStyled)``;
